// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zdmm","question":"styles_question__2wESn","inputVisibleButton":"styles_inputVisibleButton__WmARM","note":"styles_note__1nJTv"};